import Vue from 'vue'
import Vuex from 'vuex'
import utils from '../modules/utils'
import jwtDecode from "jwt-decode";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: null,
        refreshToken: null,
        userInfo: {},
        menuss:[]
    },
    mutations: {
        setToken(state, payload) {
            state.token = payload
        },
        setRefreshToken(state, payload) {
            state.refreshToken = payload
        },
        setUserInfo(state, payload) {
            state.userInfo = payload
        },
        getMenu(state,payload){
            state.menuss=payload
        }
    },
    actions:{
      setAuth({commit}, payload){
          const {token, refreshToken} = payload
          commit('setUserInfo', jwtDecode(token))
          commit('setToken', token)
          if (refreshToken) {
            commit('setRefreshToken', refreshToken)
          }
          localStorage.setItem('token', token)
          if (refreshToken) {
            localStorage.setItem('refreshToken', refreshToken)
          }
      },
      async getMenu({commit}){
        const menu = await this.services.menu.listarMenu()
        commit('getMenu',menu.data)
      }
    },
    modules: {
        utils,
    }
})
